import { config } from '@iheartjane/config';

export const kioskAuthenticationQueryKeys = {
  deviceGrant: () => ['kiosk', 'device', 'grant'],
  deviceAuthorization: () => ['kiosk', 'device', 'grant'],
  deviceSession: () => ['kiosk', 'device', 'session'],
  kioskUser: () => ['kiosk', 'user'],
};

export const kioskAuthenticationUrls = {
  deviceGrantBeginAuth: () =>
    `${config.apiPath}/kiosk/device_grants/begin_auth_session_via_qr`,
  deviceSession: () => `${config.apiPath}/kiosk/device_grants/sessions`,
  mfa: () => `${config.apiPath}/kiosk/users/multifactor_codes`,
  deviceAuthorization: () =>
    `${config.apiPath}/kiosk/device_grants/authorizations`,
  userSessions: () => `${config.apiPath}/kiosk/users/sessions`,
};
